import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowLeftRight"><Path fillRule="evenodd" clipRule="evenodd" d="M16.0002 22.4141L21.4144 16.9998L16.0002 11.5856L14.5859 12.9998L17.5859 15.9998L3.00015 15.9998L3.00015 17.9998H17.5859L14.5859 20.9998L16.0002 22.4141ZM9.41436 10.9998L6.41436 7.99985L21.0002 7.99985L21.0002 5.99985L6.41436 5.99985L9.41436 2.99985L8.00015 1.58564L2.58594 6.99985L8.00015 12.4141L9.41436 10.9998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftRight;
